<template>
  <GlobalWindow :title="title" :visible.sync="visible" :confirm-working="isWorking" @confirm="confirm">
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="模板配置ID" prop="templateConfigId"><el-input v-model="form.templateConfigId" placeholder="模板配置ID" /></el-form-item>
      <el-form-item label="编辑占位" prop="editorPlaceholder"><el-input v-model="form.editorPlaceholder" placeholder="编辑占位" /></el-form-item>
      <el-form-item label="保存按钮文案" prop="saveButtonText"><el-input v-model="form.saveButtonText" placeholder="保存按钮文案" /></el-form-item>
      <el-form-item label="觉察按钮文案" prop="awarenessButtonText"><el-input v-model="form.awarenessButtonText" placeholder="觉察按钮文案" /></el-form-item>
      <el-form-item label="显示情绪面板" prop="showMoodPanel"><el-select v-model="form.showMoodPanel" placeholder="显示情绪面板">
        <el-option label="显示" value="1" />
        <el-option label="隐藏" value="0" />
      </el-select></el-form-item>
      <el-form-item label="显示天气" prop="showWeather"><el-select v-model="form.showWeather" placeholder="显示天气">
        <el-option label="显示" value="1" />
        <el-option label="隐藏" value="0" />
      </el-select></el-form-item>
      <el-form-item label="显示位置" prop="showLocation"><el-select v-model="form.showLocation" placeholder="显示位置">
        <el-option label="显示" value="1" />
        <el-option label="隐藏" value="0" />
      </el-select></el-form-item>
    </el-form>
  </GlobalWindow>
</template>
<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'operadiaryTemplateWindow', extends: BaseOpera, components: { GlobalWindow },
  data() { return { form: { id: null, templateConfigId: '', editorPlaceholder: '', saveButtonText: '', awarenessButtonText: '', showMoodPanel: '1', showWeather: '1', showLocation: '1' }, rules: {} } },
  created() { this.config({ api: '/rentHouse/diaryTemplate', 'field.id': 'id' }) }
}
</script>